import React, { useCallback } from "react";
import moment from "moment/min/moment-with-locales";
import ReportingService from "Lib/API/reporting";
import useWidgetData from "./useWidgetData";
import WidgetWrapper from "./WidgetWrapper";
import "./widgets.scss";



const YahrzeitWidget = ({ customizeMode, onRemove, settings }) => {
  const dateType = settings?.dateType || "english";
  const fetcher = useCallback(
    (token) => ReportingService.getWidgetYahrzeits(token, dateType),
    [dateType]
  );
  const { data, loading, error, retry } = useWidgetData(fetcher);

  const items = data?.upcoming || [];

  return (
    <WidgetWrapper
      title="Upcoming Yahrzeits"
      loading={loading}
      error={error}
      onRetry={retry}
      customizeMode={customizeMode}
      onRemove={onRemove}
    >
      {items.length === 0 ? (
        <div className="list-widget__empty">No yahrzeits in the next 7 days</div>
      ) : (
        <div className="widget-scroll-list" style={{ maxHeight: 400 }}>
          {items.map((y, i) => {
            const mon = moment(y.date).format("MMM");
            const day = moment(y.date).format("D");
            const isToday = y.daysUntil === 0;
            const dayPill = isToday ? "Today" : y.daysUntil === 1 ? "Tomorrow" : `${y.daysUntil}d`;
            const primaryName = y.deceasedName || "—";
            const subLine = (y.relations || []).join(", ");
            const dateBadge = dateType === "hebrew" ? y.hebrewDateStr : y.englishDateStr;
            const isHebrew = dateType === "hebrew";
            return (
              <div key={i} className="yahr-row">
                <div className="yahr-date">
                  <div className="yahr-date__month">{mon}</div>
                  <div className="yahr-date__day">{day}</div>
                </div>
                <div className="yahr-info">
                  <div className="yahr-info__name">{primaryName}</div>
                  {subLine ? <div className="yahr-info__rel">{subLine}</div> : null}
                  {dateBadge ? (
                    <div className="yahr-info__dates">
                      <span
                        className={`yahr-info__date-tag${isHebrew ? " yahr-info__date-tag--heb" : ""}`}
                        dir={isHebrew ? "rtl" : undefined}
                      >
                        {dateBadge}
                      </span>
                    </div>
                  ) : null}
                </div>
                <div className={`yahr-days${isToday ? " yahr-days--today" : ""}`}>{dayPill}</div>
              </div>
            );
          })}
        </div>
      )}
    </WidgetWrapper>
  );
};

export default YahrzeitWidget;
